export enum SessionService {
    CHILD_THERAPY = "child_therapy",
    COUPLES_THERAPY = "couples_therapy",
    FAMILY_THERAPY = "family_therapy",
    INDIVIDUAL_THERAPY = "individual_therapy",
    INTUITIVE_EATING = "intuitive_eating",
    MEDICATION_MANAGEMENT = "medication_management",
    MENTAL_HEALTH_ASSESSMENT = "mental_health_assessment",
    PSYCHIATRIC_COUNSELLING = "psychiatric_counseling",
    TELETHERAPY = "teletherapy",
    CAREER_ASSESSMENT = "career_assessment",
    EXTERN_THERAPY = "extern_therapy",
    GIFTED_ASSESSMENT = "gifted_assessment",
    SHORT_TERM_EVALUATION_DOCUMENTATION = "short_term_evaluation_documentation",
    KETAMINE_ASSISTED_PSYCHOTHERAPY = "ketamine_assisted_psychotherapy",
    KETAMINE_ASSISTED_PSYCHOTHERAPY_EVALUATION = "ketamine_assisted_psychotherapy_evaluation",
}

export interface SvgProps {
    /** extra classname for styling svg */
    className?: string;
    /** prop for updating the svg path stroke color */
    stroke?: string;
    /** prop for updating the svg path fill color */
    fill?: string;
    /** prop for adding stroke width */
    strokeWidth?: string;
}

export enum IAppCustomDates {
    ALL_TIME = "all_time",
    LAST_24_HRS = "last_24_hrs",
    THIS_WEEK = "this_week",
    LAST_WEEK = "last_week",
    LAST_TWO_WEEKS = "last_two_weeks",
    THIS_MONTH = "this_month",
    LAST_MONTH = "last_month",
    LAST_30_DAYS = "last_30_days",
    LAST_60_DAYS = "last_60_days",
    LAST_90_DAYS = "last_90_days",
    LAST_120_DAYS = "last_120_days",
    THIS_YEAR = "this_year",
}

export interface ITelehealthCallParticipants {
    name: string;
    user_id: string;
    role: string;
    status: string;
    id: string;
    updated_at: string;
    session_history_id: string;
}
